export default __webpack_public_path__ + "static/media/dummy_thumb_1.a277c0ea.png";